<template>
    <div class="clearfix">
        <titles :class="{ pageZoom }" :vipState="vipState"></titles>
        <full-page ref="fullpage" :options="options" id="fullpage">
            <div class="section">
                <headers :class="{ pageZoom }" :vipState="vipState" @showDialog="showDialog" @showHyxy="showHyxyDialog"></headers>
            </div>
            <!-- 会员特权介绍 -->
            <div class="section">
                <!-- 保证每次进入页面都可以淡入淡出效果 -->
                <transition name="fade">
                    <vip-introduce :class="{ pageZoom }" v-show="currentPage === 1" @showDialog="showDialog"></vip-introduce>
                </transition>
            </div>
            <!-- 求职特权 -->
            <div class="section">
                <job-privilege :class="{ pageZoom }" @showDialog="showDialog" @showPrivilDialog='showPrivilDialog' @buyDialog="buyVipDialog" :vipState="vipState"></job-privilege>
            </div>
            <!-- 求职保障 -->
            <div class="section">
                <job-safeguard :class="{ pageZoom }" @showDialog="showDialog" @showPrivilDialog='showPrivilDialog' @buyDialog="buyVipDialog"></job-safeguard>
            </div>
            <!-- 个人特权 -->
            <div class="section">
                <iden-privilege :class="{ pageZoom }" @showDialog="showDialog" @showPrivilDialog='showPrivilDialog' @buyDialog="buyVipDialog"></iden-privilege>
            </div>
            <!-- 购买卡片 -->
            <div class="section">
                <vip-card :class="{ pageZoom }" @showDialog="showDialog"></vip-card>
            </div>
            <!-- 求职分析 -->
            <div class="section">
                <job-analysis :class="{ pageZoom }" @showDialog="showDialog" :vipState="vipState"></job-analysis>
            </div>
        </full-page>
        <div class="controller">
            <ul>
                <li v-for="index in pageNum" @click="changePage(index, 'pc-cvip-louti-' + actionType[index-1])" :key="'controller-'+ index" :data-index="index" class="controller-item" :class="{current: index === currentPage+1}">{{index > 10 ? index : '0' + index }}</li>
                <li class="ciecle-svg-wrap">
                    <!-- svg 动画 -->
                    <div class="ciecle-svg"></div>
                    <div class="arror-top" @click="nextPrev('top')"></div>
                    <div class="arror-down" @click="nextPrev('down')"></div>
                </li>
            </ul>
        </div>
        <!-- 购买弹窗 -->
        <BuyDialog @closeDialog="closeDialog" @showHyxy="showHyxyDialog" v-if="buyDialog === true" :cardChoose="cardChoose"></BuyDialog>
        <!-- 会员协议 -->
	    <hyxy-dialog v-if="showHyxy" @closeDialog='closeDialog'></hyxy-dialog>
        <!-- 简历置顶 -->
        <jlzd-dialog v-if="showJlzd" @closeDialog='closeDialog' @buyDialog="buyVipDialog"></jlzd-dialog>
        <!-- 应聘优先 -->
        <ypyx-dialog v-if="showYpyx" @closeDialog='closeDialog' @buyDialog="buyVipDialog"></ypyx-dialog>
        <!-- 极速沟通 -->
        <!-- <jsgt-dialog v-if="showJsgt" @closeDialog='closeDialog' @buyDialog="buyVipDialog"></jsgt-dialog> -->
        <!-- 免费刷新 -->
        <wxsx-dialog v-if="showWxsx" @closeDialog='closeDialog' @buyDialog="buyVipDialog"></wxsx-dialog>
        <!-- 投递特权 -->
        <tdtq-dialog v-if="showTdtq" @closeDialog='closeDialog' @buyDialog="buyVipDialog"></tdtq-dialog>
        <!-- 求职分析 -->
        <qzfx-dialog v-if="showQzfx" @closeDialog='closeDialog' @buyDialog="buyVipDialog"></qzfx-dialog>
        <!-- 求职保障 -->
        <qzbz-dialog v-if="showWxbp" @closeDialog='closeDialog' @buyDialog="buyVipDialog" :vipState="vipState"></qzbz-dialog>
        <!-- 信息保真 -->
        <!-- <xxbz-dialog v-if="showXxbz" @closeDialog='closeDialog' @buyDialog="buyVipDialog" :vipState="vipState"></xxbz-dialog> -->
        <!-- 财产安全 -->
        <ccaq-dialog v-if="showCcaq" @closeDialog='closeDialog' @buyDialog="buyVipDialog" :vipState="vipState"></ccaq-dialog>
        <!-- 专属客服 -->
        <zskf-dialog v-if="showZskf" @closeDialog='closeDialog' @buyDialog="buyVipDialog" :vipState="vipState"></zskf-dialog>
        <!-- 尊贵标识 -->
        <zgbs-dialog v-if="showZgbs" @closeDialog='closeDialog' @buyDialog="buyVipDialog"></zgbs-dialog>
        <!-- 个人认证 -->
        <grrz-dialog v-if="showGrrz" @closeDialog='closeDialog' @buyDialog="buyVipDialog"></grrz-dialog>
        <!-- 黄金两点 -->
        <hjld-dialog v-if="showHjld" @closeDialog='closeDialog' @buyDialog="buyVipDialog"></hjld-dialog>
    </div>
</template>
<script>
    import Titles from '../modules/title/Title';                    // 顶部
    import Headers from '../modules/header/Header';                 // 第一页
    import VipIntroduce from '../modules/vipIntroduce/VipIntroduce';// 会员特权介绍  (第二页)
    import JobPrivilege from '../modules/privileges/JobPrivilege';  // 求职特权      (第三页)
    import JobSafeguard from '../modules/privileges/JobSafeguard';  // 求职保障      (第四页)
    import IdenPrivilege from '../modules/privileges/IdenPrivilege';// 身份特权      (第五页)
    import VipCard from '../modules/vipCards/VipCard';              // 会员套餐展示  (第六页)
    import JobAnalysis from '../modules/jobAnalysis/JobAnalysis';   // 求职分析      (第七页)
    import Footers from '../modules/footer/Footer';
    //求职特权
    import BuyDialog from '../modules/dialog/BuyDialog';            //购买弹窗
    import HyxyDialog from '../modules/dialog/HyxyDialog';          //会员协议
    import JlzdDialog from '../modules/dialog/JlzdDialog';          //简历置顶
    import YpyxDialog from '../modules/dialog/YpyxDialog';          //应聘优先
    // import JsgtDialog from '../modules/dialog/JsgtDialog';          //极速沟通
    import WxsxDialog from '../modules/dialog/WxsxDialog';          //免费刷新
    import TdtqDialog from '../modules/dialog/TdtqDialog';          //投递特权
    import QzfxDialog from '../modules/dialog/QzfxDialog';          //求职分析
    //求职保障
    import QzbzDialog from '../modules/dialog/QzbzDialog';          //求职保障
    // import XxbzDialog from '../modules/dialog/XxbzDialog';          //信息保真
    import CcaqDialog from '../modules/dialog/CcaqDialog';          //财产安全
    import ZskfDialog from '../modules/dialog/ZskfDialog';          //专属客服
    //个人特权
    import ZgbsDialog from '../modules/dialog/ZgbsDialog';          // 尊贵标识
    import GrrzDialog from '../modules/dialog/GrrzDialog';          // 个人认证
    import HjldDialog from '../modules/dialog/HjldDialog';          // 黄金亮点
    import { mapGetters } from 'vuex';

	export default {
		components: {
            Titles,         // 顶部
            Headers,        // 第一页展示
            VipIntroduce,   // 会员介绍
            JobPrivilege,   // 求职特权介绍
            JobSafeguard,   // 求职保障特权
            IdenPrivilege,  // 身份特权
            VipCard,        // 购买会员
            JobAnalysis,    // 求职分析
            Footers,        // 底部
            BuyDialog,      // 购买弹窗
            HyxyDialog,     // 会员协议
            //求职特权
            JlzdDialog,     //简历置顶
            YpyxDialog,     //应聘优先     
            // JsgtDialog,     //极速沟通     
            WxsxDialog,     //免费刷新     
            TdtqDialog,     //投递特权     
            QzfxDialog,     //求职分析
            //求职保障
            QzbzDialog,     //求职保障
            // XxbzDialog,     //信息保真
            CcaqDialog,     //财产安全
            ZskfDialog,     //专属客服
            //个人特权
            ZgbsDialog,     //尊贵标识
            GrrzDialog,     //个人认证
            HjldDialog,     //黄金亮点
        },
        props: ['vipState', 'pageZoom'],
        data () {
            var _this = this;
            return {
                cardChoose: 58,
                currentPage: 0,
                //fullpage
                options: {
                    licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',  
                    scrollBar: false,
                    sectionsColor: ['#232020', '#232020', '#232020', '#232020', '#232020', '#232020', '#232020'],
                    onLeave: _this.onLeave
                },
                //埋点使用
                actionType: ['one', 'two', 'three', 'four', 'five', 'six', 'seven'],
                buyDialog: false,   //购买弹窗
                //求职特权
                showHyxy: false,   //会员协议
                showJlzd: false,   //简历置顶
                showWxsx: false,   //免费刷新              
                showYpyx: false,   //应聘优先
                showQzfx: false,   //求职分析
                // showJsgt: false,   //极速沟通
                showTdtq: false,   //投递特权
                //求职保障
                showWxbp: false,    //无效包赔
                // showXxbz: false,    //信息保真
                showCcaq: false,    //财产安全
                showZskf: false,    //专属客服
                //身份特权
                showZgbs: false,   //尊贵标识
                showGrrz: false,   //个人认证
                showHjld: false,   //黄金亮点
            }
        },
        mounted() { },
        methods: {
            closeDialog () {
                this.showHyxy = false;
                this.buyDialog = false;
                //求职特权
                this.showWxsx = false
                this.showYpyx = false;
                this.showQzfx = false;
                this.showJlzd = false;
                this.showJsgt = false;
                this.showTdtq = false;
                //求职保障
                this.showWxbp = false;
                // this.showXxbz = false;
                this.showCcaq = false;
                this.showZskf = false;
                //身份特权
                this.showZgbs = false;               
                this.showGrrz = false;
                this.showHjld = false;
            },
            //购买弹窗显示
            showDialog ( cardType = 58 ) {
                this.buyDialog = true;
                this.cardChoose = cardType;
            },
            //购买弹窗
            buyVipDialog() {
                this.closeDialog();
                this.showDialog();
            },
            // 会员协议
            showHyxyDialog () {
                this.showHyxy = true;
            },
            // 显示会员弹窗
            showPrivilDialog(type){
                
                switch (type) {
                    // 求职特权
                    // case 'jsgt': //极速沟通
                    //     this.showJsgt = true;
                    //     break;
                    case 'ypyx': //应聘优先
                        this.showYpyx = true;
                        break;
                    case 'tdfb': //投递翻倍
                        this.showTdtq = true;
                        break;
                    case 'wxsx': //免费刷新
                        this.showWxsx = true;
                        break;
                    case 'jlzd': //简历置顶
                        this.showJlzd = true;
                        break;
                    case 'qzfx': //求职分析
                        this.showQzfx = true;
                        break;

                    // 求职保障
                    case 'wxbp': //无效包赔
                        this.showWxbp = true;
                        break;
                    // case 'xxbz': //信息保真
                    //     this.showXxbz = true;
                    //     break;
                    case 'ccaq': //财产安全
                        this.showCcaq = true;
                        break;
                    case 'zskf': //专属客服
                        this.showZskf = true;
                        break;

                    // 个人特权
                    case 'zgbs': //尊贵标识
                        this.showZgbs = true;
                        break;
                    case 'grrz': //个人认证
                        this.showGrrz = true;
                        break;
                    case 'hjld': //黄金两点
                        this.showHjld = true;
                        break;
                };
            },
            /**
             * origin: 从哪里到当前页面
             * destination: 当前页面
             * direction: 滚动方向
             */
            onLeave(origin, destination, direction){
                this.currentPage = destination.index;
            },
            changePage(index, actionType){
                //跳转
                fullpage_api.moveTo(index);
                window.clickLog && window.clickLog(`from=pc-cvip-louti--${actionType}-new`)
            },
            nextPrev(actionType){
                window.clickLog && window.clickLog(`from=pc-cvip-louti--${actionType}-new`)
            }
        },
        computed: {
            pageNum(){
                return this.options.sectionsColor.length;
            },
            ...mapGetters({
                mealInfo: 'mealInfo'		// 购买套餐信息
            })
        }

	}
	
</script>

<style type="text/css" lang="scss" scope>
    @import "../../../assets/css/public.scss";
    
    .controller {
		position: fixed;
		right: 5%;
		top: 50%;
		z-index: 99;
	}
    .controller ul {
		transform: translate3d(0, -50%, 0);
		list-style: none;
		margin: 0;
		padding: 0;
	}
	.controller-item {
		cursor: pointer;
		font-size: 18px;
		color: #FFFFFF;
		letter-spacing: 0;
        font-family: 'DIN-Bold';
		margin-bottom: 17px;
		opacity: .3;
	}
	.controller-item:hover {
		font-size: 18px;
		color: #FFFFFF;
		letter-spacing: 0;
		opacity: 1;
	}
	.controller-item.current {
		font-size: 18px;
		color: #FFFFFF;
		letter-spacing: 0;
		opacity: 1;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
        -moz-transition: all .5s;
        -webkit-transition: all .5s;
        -o-transition: all .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    /*svg*/ 
	.ciecle-svg-wrap {
		position: relative;
		width: 100%;
		height: 100%;
	}
	/* svg */
	.ciecle-svg {
		position: absolute;
		top: 0;
		right: -5px;
		width: 30px;
        height: 60px;
        opacity: .7;
		border-radius: 18px;
		background-image: url(../../../assets/imgs/circle-bg.svg);
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;
	}
	.arror-top{
		width:0px;
		height:0px;
		border-top:5px solid rgba(0,0,0,0);
		border-right:5px solid  rgba(0,0,0,0);
		border-bottom:5px solid #846A5C;
		border-left:5px solid  rgba(0,0,0,0);
		position: absolute;
		left: 5px;
		top: 6px;
	}
	.arror-down{
		width:0px;
		height:0px;
		border-top:5px solid #846A5C;
		border-right:5px solid  rgba(0,0,0,0);
		border-bottom:5px solid  rgba(0,0,0,0);
		border-left:5px solid  rgba(0,0,0,0);
		position: absolute;
		left: 5px;
		top: 44px;
    }
    .pageZoom{
        transform: scale(0.8);
        -moz-transform: scale(0.8);
        -ms-transform: scale(0.8);
        -webkit-transform: scale(0.8);
        -o-transform: scale(0.8);
    }
</style>



// WEBPACK FOOTER //
// VipNo.vue?0a0ea88a